import { Box, Flex } from '@chakra-ui/react'
import Pitch from './Pitch'
import LoginOptions from './LoginOptions'
import DisplayNameFieldSet from './DisplayNameFieldSet'
import EmailFieldSet from './EmailFieldSet'
import LoginFormContainer from './LoginFormContainer'
import { Step, StepForm } from 'src/common/StepForm'
import EmailSignupConfirmation from './EmailSignupConfirmation'
import { Authenticate } from './Login'

function Signup() {
  return (
    <Authenticate>
      {({ onSubmit, onSuccessfulGoogleLogin }) => (
        <Flex h='100vh' layerStyle='appContainer'>
          <Box
            w={['100%', '100%', '60%']}
          >
            <LoginFormContainer
              mx='auto'
              mt={[8, 8, 24]}
            >
              <StepForm onSubmit={onSubmit}>
                <Step name='options'>
                  <LoginOptions
                    onSuccess={onSuccessfulGoogleLogin}
                  />
                </Step>
                <Step name='display-name'>
                  <DisplayNameFieldSet />
                </Step>
                <Step name='email'>
                  <EmailFieldSet />
                </Step>
                <Step name='confirm'>
                  <EmailSignupConfirmation />
                </Step>
              </StepForm>
            </LoginFormContainer>
          </Box>
          <Box
            w='40%'
            d={['none', 'none', 'block']}
          >
            <Pitch
              mx='auto'
              maxW='420px'
              mt={24}
            />
          </Box>
        </Flex>
      )}
    </Authenticate>
  )
}

export default Signup
